import { useRevenueSummary, useRevenueStreams } from "@/hooks/use-mock-data";

export function RevenueStreamsSummary() {
  const { data: summary } = useRevenueSummary();
  const { data: streams } = useRevenueStreams();

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 space-y-2.5">
        {streams
          .filter((s) => s.isActive)
          .map((stream) => {
            const streamData = summary.byStream.find(
              (b) => b.streamId === stream.id
            );
            const current = streamData?.total ?? 0;
            const pct = Math.min((current / stream.targetMonthly) * 100, 100);

            return (
              <div key={stream.id}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-[12px] text-[#8A9A98] truncate mr-2">
                    {stream.name}
                  </span>
                  <span className="font-mono text-[12px] text-foreground shrink-0">
                    ${current.toLocaleString()}
                  </span>
                </div>
                <div className="h-1.5 bg-[rgba(255,255,255,0.06)] rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full animate-progress-sweep"
                    style={{
                      width: `${pct}%`,
                      backgroundColor:
                        pct >= 80
                          ? "#44F2D2"
                          : pct >= 40
                            ? "#4B75F2"
                            : "#CC2936",
                    }}
                  />
                </div>
              </div>
            );
          })}
      </div>
      <div className="mt-3 pt-2 border-t border-[rgba(255,255,255,0.06)] flex items-center justify-between">
        <span className="text-[11px] text-[#5A6A68] uppercase tracking-wider">
          Total
        </span>
        <span className="font-mono font-bold text-[14px] text-foreground">
          ${summary.currentMonth.toLocaleString("en-US", { minimumFractionDigits: 2 })}
        </span>
      </div>
    </div>
  );
}
